export class LoggerService implements Console {
  serviceName: string | null = null;

  constructor(serviceName: string) {
    this.serviceName = serviceName;
  }

  private prefixMessage(message: string): string {
    return `[${this.serviceName}] ${message}`;
  }

  log(...args: unknown[]): void {
    console.log(this.prefixMessage(String(args[0] || "")), ...args.slice(1));
  }

  error(...args: unknown[]): void {
    console.error(this.prefixMessage(String(args[0] || "")), ...args.slice(1));
  }

  debug(...args: unknown[]): void {
    console.debug(this.prefixMessage(String(args[0] || "")), ...args.slice(1));
  }

  warn(...args: unknown[]): void {
    console.warn(this.prefixMessage(String(args[0] || "")), ...args.slice(1));
  }

  info(...args: unknown[]): void {
    console.info(this.prefixMessage(String(args[0] || "")), ...args.slice(1));
  }

  trace(...args: unknown[]): void {
    console.trace(this.prefixMessage(String(args[0] || "")), ...args.slice(1));
  }

  group(...args: unknown[]): void {
    console.group(this.prefixMessage(String(args[0] || "")), ...args.slice(1));
  }

  groupEnd(): void {
    console.groupEnd();
  }

  groupCollapsed(...args: unknown[]): void {
    console.groupCollapsed(this.prefixMessage(String(args[0] || "")), ...args.slice(1));
  }

  assert(condition?: boolean, ...args: unknown[]): void {
    console.assert(condition, this.prefixMessage(String(args[0] || "")), ...args.slice(1));
  }

  clear(): void {
    console.clear();
  }

  count(label?: string): void {
    console.count(label ? `${this.serviceName}:${label}` : this.serviceName || undefined);
  }

  countReset(label?: string): void {
    console.countReset(label ? `${this.serviceName}:${label}` : this.serviceName || undefined);
  }

  dir(item?: unknown, options?: unknown): void {
    console.dir(item, options);
  }

  dirxml(...args: unknown[]): void {
    console.dirxml(...args);
  }

  table(tabularData?: unknown, properties?: string[]): void {
    console.table(tabularData, properties);
  }

  time(label?: string): void {
    console.time(label ? `${this.serviceName}:${label}` : this.serviceName || undefined);
  }

  timeEnd(label?: string): void {
    console.timeEnd(label ? `${this.serviceName}:${label}` : this.serviceName || undefined);
  }

  timeLog(label?: string, ...args: unknown[]): void {
    console.timeLog(label ? `${this.serviceName}:${label}` : this.serviceName || undefined, ...args);
  }

  timeStamp(label?: string): void {
    console.timeStamp(label ? `${this.serviceName}:${label}` : this.serviceName || undefined);
  }
}
